import { batch, computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"


export const isLoadingAcrissGroupData = signal(true)
export const acrissGroupData = signal([])
export const acrissGroupFormData = signal({})

// Computed
export const isOpenAcrissGroupDrawer = computed(() => !isEmpty(acrissGroupFormData.value))
export const isEditAcrissGroupDrawer = computed(() => acrissGroupFormData.value?.id !== null)

// Functions
export const clearAcrissGroupSignals = () => batch(() => {
	isLoadingAcrissGroupData.value = true
	acrissGroupData.value = []
	acrissGroupFormData.value = {}
})
